import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { RouterLink } from 'APP/router/constants';

import { usePublicDomainPresenter } from './PublicDomain.presenter';

interface IPublicDomainProps {
  redirectTo?: string;
  isAllowed?: boolean;
}

export const PublicDomain: FC<PropsWithChildren<IPublicDomainProps>> = observer(
  ({ redirectTo = RouterLink.Main, isAllowed, children }) => {
    const presenter = usePublicDomainPresenter();
    const location = useLocation();

    if (presenter.isShowSkeleton) {
      return null;
    }

    if (!presenter.isAllowedPublicContent && !isAllowed) {
      return (
        <Navigate
          to={{
            pathname: redirectTo,
            search: location.search,
          }}
          replace
        />
      );
    }

    return <>{children}</>;
  }
);
